<template>
  <div class="grid-box">
    <span v-translate>{{ label }}</span>
    <span class="embolden">{{ value }}</span>
  </div>
</template>
<script>

  export default {
    name: 'text-cell-component',
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
      }
    }
  }

</script>
<style lang="sass" scoped>
  .embolden
    font-weight: bold
    word-break: break-all
</style>
